var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "value": _vm.open,
      "onClose": _vm.close,
      "close": false,
      "size": "small"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Impostos do Item")]), _c('b-row', {
    staticClass: "form-group"
  }, [_c('b-col', {
    staticClass: "busca",
    attrs: {
      "md": "6"
    }
  }, [_c('Input', {
    ref: "descricao",
    attrs: {
      "label": "Descrição",
      "id": "descricao",
      "labelBold": "",
      "disabled": ""
    },
    on: {
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valueProduto.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "descricao", $$v);
      },
      expression: "valueProduto.descricao"
    }
  })], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto, "quantity", $$v);
      },
      expression: "valueProduto.quantity"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total do Item R$",
      "label-for": "totalProd"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "totalProd",
      "name": "totalProd",
      "disabled": ""
    },
    model: {
      value: _vm.totalProduto,
      callback: function callback($$v) {
        _vm.totalProduto = $$v;
      },
      expression: "totalProduto"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "BC ICMS %",
      "label-for": "baseICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "baseICMS",
      "name": "baseICMS",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.totais.baseICMS,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto.totais, "baseICMS", $$v);
      },
      expression: "valueProduto.totais.baseICMS"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor do ICMS R$",
      "label-for": "valorICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorICMS",
      "name": "valorICMS",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.totais.valorICMS,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto.totais, "valorICMS", $$v);
      },
      expression: "valueProduto.totais.valorICMS"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "BC ICMS ST R$",
      "label-for": "baseICMSST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "baseICMSST",
      "name": "baseICMSST",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.totais.baseICMSST,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto.totais, "baseICMSST", $$v);
      },
      expression: "valueProduto.totais.baseICMSST"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor ICMS ST R$",
      "label-for": "valorICMSST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorICMSST",
      "name": "valorICMSST",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.totais.valorICMSST,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto.totais, "valorICMSST", $$v);
      },
      expression: "valueProduto.totais.valorICMSST"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor IPI R$",
      "label-for": "valorIPI"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorIPI",
      "name": "valorIPI",
      "disabled": ""
    },
    model: {
      value: _vm.valueProduto.totais.valorIPI,
      callback: function callback($$v) {
        _vm.$set(_vm.valueProduto.totais, "valorIPI", $$v);
      },
      expression: "valueProduto.totais.valorIPI"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('b-row'), _c('div', {
    staticClass: "confirm-buttons"
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };